<template>
  <main id="main-content" tabindex="-1" class="login__wrapper">
    <div class="login__mobile-warning">
      <VisibleText>
        Caution: ResearchAI has not yet been optimized for mobile experience.
      </VisibleText>
    </div>
    <div class="login__content">
      <h1 class="login__title">Login</h1>
      <p>
        <VisibleText> Welcome! Please login below to access your analytics platform. </VisibleText>
      </p>
      <div class="message" v-if="message">{{ message }}</div>
      <Login class="login__form" @authenticated="afterLogin">
        <template #default="{ email, password, update }">
          <label for="email" class="form-style-group-label">
            <span class="form-style-group-text">
              <VisibleText>Email Address</VisibleText>
            </span>
            <div class="form-style-group-input-wrapper">
              <EmailIcon class="form-style-group-input-icon"> </EmailIcon>
              <input
                id="email"
                @input="update('email', $event.target.value)"
                type="text"
                :value="email"
              />
            </div>
          </label>

          <label for="password" class="form-style-group-label">
            <span class="form-style-group-text">
              <VisibleText>Password</VisibleText>
            </span>
            <div class="form-style-group-input-wrapper">
              <PasswordIcon class="form-style-group-input-icon" />
              <input
                id="password"
                @input="update('password', $event.target.value)"
                type="password"
                :value="password"
              />
            </div>
          </label>
        </template>
      </Login>
      <p>
        <VisibleText>Don't have an account? </VisibleText>
        <!-- <router-link to="/register">
          <VisibleText>Register Here</VisibleText>
        </router-link> -->
        <button class="link-button" @click="openRegisterModal">Sign up for a demo</button>
      </p>

      <p>
        <VisibleText>Have an invite or demo code? </VisibleText>
        <router-link class="link-button" to="/register/demo">
          <VisibleText>Enter it Here</VisibleText>
        </router-link>
      </p>
    </div>
    <RegisterSmallModal
      :status="isRegisterSmallExpanded"
      @close="isRegisterSmallExpanded = false"
      @registered="handleSmallRegister($event)"
    />
    <div
      class="login__splash"
      :style="{ backgroundImage: `url(${require('@/assets/splash.png')})` }"
    ></div>
  </main>
</template>

<script>
// Components
import { Login } from '@/pigeonline/wrapper';

import RegisterSmallModal from '@/components/Register/RegisterSmallModal.vue';

// Mixins
import UserMixin from '@/utils/mixins/userMixin.js';

// Icons
import EmailIcon from '@/assets/icons/Login/email.svg';
import PasswordIcon from '@/assets/icons/Login/pswd.svg';

export default {
  name: 'login',
  mixins: [UserMixin],
  props: {
    message: {
      type: String,
      default: () => '',
    },
  },
  components: {
    Login,
    EmailIcon,
    PasswordIcon,
    RegisterSmallModal,
  },
  created() {
    document.title = `Login | ${this.$theme.theme.pageTitle}`;
  },
  data() {
    return {
      isRegisterSmallExpanded: false,
    };
  },
  methods: {
    async afterLogin() {
      // update user store
      await this.setUserDetails();
      await this.setUserNotifications();

      // go to home page or redirect path if it exists
      const redirectPath = this.$route.query.redirect || '/projects';
      this.$router.push({ path: redirectPath });
    },
    openRegisterModal() {
      this.isRegisterSmallExpanded = true;
    },
    async handleSmallRegister(user) {
      // redirect to register verification page if is_email_verified = false
      if (!user.is_email_verified) {
        this.$router.push({
          path: 'register/verify',
          query: {
            email: user.email,
            status: 'account_created',
          },
        });
      } else {
        // login user automatically
        await this.$pigeonline.login(
          this.$refs.register.$data['email'],
          this.$refs.register.$data['password'],
        );
        this.$router.push(
          {
            path: this.$route.query.redirect || 'account/profile',
          },
          () => this.$router.go(0),
        );
      }
    },
  },
};
</script>

<style scoped>
.link-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: var(--secondary); /* RAI blue */
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
}

.link-button:hover {
  text-decoration: underline;
}
</style>
